// src/components/icons.jsx
// Small inline SVG icons (stroke style), sized to the surrounding text by default.
import React from 'react';

function Icon({ size = 18, children, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            {children}
        </svg>
    );
}

export const TrophyIcon = (props) => (
    <Icon {...props}>
        <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4z" />
        <path d="M17 5h3v2a3 3 0 0 1-3 3M7 5H4v2a3 3 0 0 0 3 3" />
    </Icon>
);

export const PlusIcon = (props) => (
    <Icon {...props}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
);

export const TrashIcon = (props) => (
    <Icon {...props}>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6" />
    </Icon>
);

export const PencilIcon = (props) => (
    <Icon {...props}>
        <path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
    </Icon>
);

export const ChevronIcon = ({ open, ...props }) => (
    <Icon className={`chevron${open ? ' open' : ''}`} {...props}>
        <path d="M6 9l6 6 6-6" />
    </Icon>
);

export const ShareIcon = (props) => (
    <Icon {...props}>
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4" />
    </Icon>
);

export const ArrowLeftIcon = (props) => (
    <Icon {...props}>
        <path d="M19 12H5M12 19l-7-7 7-7" />
    </Icon>
);

export const UploadIcon = (props) => (
    <Icon {...props}>
        <path d="M12 16V4M7 9l5-5 5 5M5 20h14" />
    </Icon>
);

export const DownloadIcon = (props) => (
    <Icon {...props}>
        <path d="M12 4v12M7 11l5 5 5-5M5 20h14" />
    </Icon>
);

export const CopyIcon = (props) => (
    <Icon {...props}>
        <rect x="8" y="8" width="13" height="13" rx="2" />
        <path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" />
    </Icon>
);

export const PrinterIcon = (props) => (
    <Icon {...props}>
        <path d="M6 9V3h12v6M6 18H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2" />
        <rect x="6" y="14" width="12" height="7" />
    </Icon>
);

export const LockIcon = (props) => (
    <Icon {...props}>
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </Icon>
);

export const GoogleIcon = (props) => (
    <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true" focusable="false" {...props}>
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
);

export const UsersIcon = (props) => (
    <Icon {...props}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </Icon>
);

export const EyeIcon = (props) => (
    <Icon {...props}>
        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
        <circle cx="12" cy="12" r="3" />
    </Icon>
);

export const EyeOffIcon = (props) => (
    <Icon {...props}>
        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19C5 19 1 12 1 12a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.1 9.1 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19M14.12 14.12a3 3 0 1 1-4.24-4.24" />
        <path d="M1 1l22 22" />
    </Icon>
);

export const AppleIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
        <path d="M16.37 12.6c-.03-2.6 2.13-3.85 2.23-3.91-1.21-1.77-3.1-2.02-3.77-2.05-1.6-.16-3.13.94-3.94.94-.82 0-2.07-.92-3.4-.9-1.75.03-3.36 1.02-4.26 2.58-1.82 3.15-.47 7.82 1.3 10.38.87 1.25 1.9 2.65 3.25 2.6 1.3-.05 1.8-.84 3.38-.84s2.03.84 3.4.81c1.41-.02 2.29-1.27 3.15-2.53.99-1.45 1.4-2.85 1.43-2.92-.03-.01-2.73-1.05-2.76-4.16zM13.78 4.96c.72-.87 1.2-2.08 1.07-3.29-1.03.04-2.28.69-3.02 1.55-.66.77-1.24 2-1.09 3.18 1.15.09 2.32-.58 3.04-1.44z" />
    </svg>
);

export const RoundsIcon = (props) => (
    <Icon {...props}>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 12h18M12 4v16" />
    </Icon>
);

export const RankingIcon = (props) => (
    <Icon {...props}>
        <path d="M8 21V11H3v10zM14 21V3H9v18zM21 21v-7h-5v7z" />
    </Icon>
);

export const MoreIcon = (props) => (
    <Icon {...props}>
        <circle cx="5" cy="12" r="1" />
        <circle cx="12" cy="12" r="1" />
        <circle cx="19" cy="12" r="1" />
    </Icon>
);

export const CheckIcon = (props) => (
    <Icon {...props}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
);
